<vc-dialog
    [(visible)]="visible"
    [title]="'ASSESSMENT.MILESTONES.TITLE.MILESTONE_TASKS' | transloco"
    [primaryLabel]="'ASSESSMENT.MILESTONES.LABEL.OK' | transloco"
    [closeOnPrimary]="true"
    [showSecondary]="false"
    [actionsOnLeft]="false">
    @if (milestone) {
        <vc-table
            [filterLabel]="'COMMON_UI.SEARCH' | transloco"
            [noDataMsg]="'COMMON_UI.TABLE.NO_DATA_AVAILABLE' | transloco"
            [data]="milestone.tasks ?? []"
            [showPagination]="false"
            [showFilter]="true"
            [showFilterClearButton]="true"
            [multiselect]="false"
            [showColumnSelector]="false"
            [globalFilterFields]="['name', 'description']">
            <ng-template
                vcColumn
                [header]="'ASSESSMENT.COMMON.HEADER.TASK' | transloco"
                field="name"
                [sortable]="true"
                width="40%"
                let-task>
                <vc-tooltip-text [text]="task.name" [tooltipMessage]="task.name"></vc-tooltip-text>
            </ng-template>
            <ng-template vcColumn [header]="'COMMON_UI.TYPE' | transloco" field="type" width="15%" let-task>
                <vc-tooltip-text
                    [text]="task.type | referenceTaskType"
                    [tooltipMessage]="task.type | referenceTaskType"></vc-tooltip-text>
            </ng-template>
            <ng-template
                vcColumn
                [header]="'COMMON_UI.DESCRIPTION' | transloco"
                field="description"
                width="45%"
                let-task>
                <vc-tooltip-text [text]="task.description" [tooltipMessage]="task.description"></vc-tooltip-text>
            </ng-template>
        </vc-table>
    }
</vc-dialog>
